import classNames from 'classnames';
import type { ReactNode } from 'react';
import React, { memo } from 'react';

import { Badge } from '@sravni/react-design-system/lib/Badge';
import { Heading } from '@sravni/react-design-system/lib/Typography';

import styles from './FullDealEntryPointBannerForGoogle.module.scss';
import { FullDealEntryPointBannerForGoogleTexts } from './FullDealEntryPointBannerForGoogle.texts';

interface Props {
  isLanding?: boolean;
  heading?: string;
  mobileBanner: ReactNode;
}

export const FullDealEntryPointBannerForGoogle = memo(({ isLanding, heading, mobileBanner }: Props) => (
  <div className={styles.container}>
    <div className={classNames(styles.mobileBanner, 'desktop:hidden')}>{mobileBanner}</div>
    <div className={styles.header}>
      {/* todo: сделали дивом по указанию СЕО https://sravni-corp.slack.com/archives/C08LAGUJQRZ/p1755239085670589 */}
      <Heading level={isLanding ? 1 : 2} size={{ desktop: 28, mobile: 21 }} className={styles.title} as="div">
        {heading || FullDealEntryPointBannerForGoogleTexts.title}
      </Heading>
      <Badge
        variant="primary"
        color="light"
        className={styles.badge}
        text={FullDealEntryPointBannerForGoogleTexts.badgeTitleWithTime}
      />
    </div>
  </div>
));

FullDealEntryPointBannerForGoogle.displayName = 'FullDealEntryPointBannerForGoogle';
